const { parse } = require("semver")

const convertDateTimeObjectToDisplayDateTime = function(getDateTime){
  try{
    var getDate = getDateTime.getDate()
    var getMonth = getDateTime.getMonth() + 1
    var getYear = getDateTime.getFullYear()
    var getHours = getDateTime.getHours()
    var getMinutes = getDateTime.getMinutes()
    getMonth = getMonthName(getMonth)
    return getDate + " " + getMonth + " " + getYear + ", " + getHours + ":" + getMinutes

  }catch (err){
    console.log("convertDateTimeObjectToDisplayDateTime error parsing " + getDateTime)
    return "";
  }
}

const getPlanName = function(plan){
  plan = parseInt(plan)
  if (plan == 1){
    return "PREMIUM UNLIMITED BEHAVIOR"
  }else if (plan == 2){
    return "PREMIUM UNLIMITED BEHAVIOR (1 MONTH TRIAL)"
  }else if (plan == 3){
    return "ATTENDANCE UNLIMITED (FREE FOREVER)"
  }else{
    return "Invalid Plan"
  }
}

//return date in YYYYMMDD to better format
const displayActionDate = function(actionDate){
  if (actionDate.length != 8){
    console.log("invalid actionDate format received by helper.displayActionDate")
    return false;
  }
  var year = actionDate.substring(0,4)
  var strMonth = actionDate.substring(4,6)
  var month = parseInt(strMonth)
  var strDay = actionDate.substring(6,8)
  var day = parseInt(strDay)

  return day + " " + this.displayMonth(month) + " " + year;
}

const displayMonth = function(month){
  month = parseInt(month)
  var monthDisplay = "";
  switch (month){
      case 1:
          monthDisplay = "January";
          break;
      case 2:
          monthDisplay = "February";
          break;
      case 3:
          monthDisplay = "March";
          break;
      case 4:
          monthDisplay = "April";
          break;
      case 5:
          monthDisplay = "May";
          break;
      case 6:
          monthDisplay = "June";
          break;
      case 7:
          monthDisplay = "July";
          break;
      case 8:
          monthDisplay = "August";
          break;
      case 9:
          monthDisplay = "September";
          break;
      case 10:
          monthDisplay = "October";
          break;
      case 11:
          monthDisplay = "November";
          break;
      case 12:
          monthDisplay = "December";
          break;
      default:
          monthDisplay = "";
          break;
  }
  return monthDisplay;
}
const getMonthName = function(month,display){
  console.log("Entering getMonthName with : " + month + ", display: " + display)
  if (month == 1){
    if (display == "full"){
      return "January";
    }else{
      return "Jan"
    }
  }else if (month == 2){
    if (display == "full"){
      return "February";
    }else{
      return "Feb"
    }
  }else if (month == 3){
    if (display == "full"){
      return "March";
    }else{
      return "Mar"
    }
  }else if (month == 4){
    if (display == "full"){
      return "April";
    }else{
      return "Apr"
    }
  }else if (month == 5){
    if (display == "full"){
      return "May";
    }else{
      return "May";      
    }
  }else if (month == 6){
    if (display == "full"){
      return "June";
    }else{
      return "June";      
    }
  }else if (month == 7){
    if (display == "full"){
      return "July";
    }else{
      return "Jul";      
    }
  }else if (month == 8){
    if (display == "full"){
      return "August";
    }else{
      return "Aug";      
    }
  }else if (month == 9){
    if (display == "full"){
      return "September";
    }else{
      return "Sep"      
    }
  }else if (month == 10){
    if (display == "full"){
      return "October";
    }else{
      return "Oct"
    }
  }else if (month == 11){
    if (display == "full"){
      return "November";
    }else{
      return "Nov"      
    }
  }else if (month == 12){
    if (display == "full"){
      return "December";
    }else{
      return "Dec"
    }
  }else{
    console.log("somehow masuk else lak")
    if (display == "full"){
      return "January";
    }else{
      return "Jan";      
    }
  }
}
const getExtension = function(filename){
  var i = filename.lastIndexOf('.');
  return (i < 0) ? '' : filename.substr(i+1);
}
const getDaysInMonth = function(month,year){
  return new Date(year, month, 0).getDate();
}

module.exports ={
  convertDateTimeObjectToDisplayDateTime:convertDateTimeObjectToDisplayDateTime,
  getPlanName:getPlanName,
  displayActionDate:displayActionDate,
  displayMonth:displayMonth,
  getMonthName:getMonthName,
  getExtension:getExtension,
  getDaysInMonth:getDaysInMonth
}


//////////////////
// WEBPACK FOOTER
// ./config/helper.js
// module id = 4MGd
// module chunks = 1